/**
 * Responsive breakpoints shared with the CSS (keep in sync with the media
 * queries in the *.module.css files): phone < 768 px, tablet 768-1023 px,
 * desktop >= 1024 px.
 */
import { useSyncExternalStore } from 'react';

export const PHONE_QUERY = '(max-width: 767.98px)';
export const DESKTOP_QUERY = '(min-width: 1024px)';

function matches(query: string): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function' && window.matchMedia(query).matches;
}

export function useMediaQuery(query: string): boolean {
  return useSyncExternalStore(
    (onChange) => {
      if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return () => undefined;
      const mql = window.matchMedia(query);
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    },
    () => matches(query),
    () => false,
  );
}

export const useIsPhone = () => useMediaQuery(PHONE_QUERY);
export const useIsDesktop = () => useMediaQuery(DESKTOP_QUERY);
